import { baseRoutes } from '@routes/helpers/baseRoutes.ts';
import { routesPaths } from '@routes/helpers/constants.ts';
import { AppRouteConfig } from '@routes/route';

export const campaignsRoutes: ReadonlyArray<AppRouteConfig> = [
  {
    path: baseRoutes.campaigns.root,
    lazyImport: () => import('../../domains/protected/campaigns/CampaignsRoute.tsx'),
    requiresAuth: true,
    resourceId: 'campaign',
    children: [
      {
        index: true,
        redirectTo: routesPaths.campaigns.list.root
      },
      {
        path: baseRoutes.campaigns.list.root,
        lazyImport: () =>
          import('../../domains/protected/campaigns/pages/campaigns/campaigns-list/CampaignsListRoute.tsx'),
        nav: {
          hideBack: true,
          breadcrumbKey: 'list'
        }
      },
      {
        path: baseRoutes.campaigns.tags,
        lazyImport: () =>
          import('../../domains/protected/campaigns/pages/tags/tags-list/TagsListRoute.tsx'),
        resourceId: 'campaign',
        redirectUnauthorizedTo: routesPaths.campaigns.root,
        nav: {
          hideBack: true,
          breadcrumbKey: 'list'
        }
      },
      {
        path: baseRoutes.campaigns.list.new,
        lazyImport: () =>
          import('../../domains/protected/campaigns/pages/campaigns/add-campaign/CampaignAddRoute.tsx'),
        nav: {
          backTo: routesPaths.campaigns.root,
          breadcrumbKey: 'new'
        }
      },
      {
        path: baseRoutes.campaigns.list.details,
        lazyImport: () =>
          import('../../domains/protected/campaigns/pages/campaigns/campaign-details/CampaignDetailsRoute.tsx'),
        nav: {
          backTo: routesPaths.campaigns.root,
          breadcrumbKey: 'details'
        }
      },
      {
        path: '*',
        redirectTo: routesPaths.campaigns.root
      }
    ]
  }
];
